import {
  exportToExcel,
  getExportAiModelOptions,
} from 'components/AITools/utilities/common';
import { useSlidesModelQuantification } from 'components/AITools/hooks/useModelQuantifications';
import { useState } from 'react';

export const useExportSlidesQuantification = ({
  model,
  slides,
  opacityOptions,
}) => {
  const [isExportingQuantification, setIsExportingQuantification] =
    useState(false);

  const getSlidesModelQuantification = useSlidesModelQuantification({
    model,
    slides,
    opacityOptions,
  });

  const exportSlidesQuantification = async () => {
    try {
      setIsExportingQuantification(true);

      const slidesAiModels = await getSlidesModelQuantification();
      const exportAIOptions = getExportAiModelOptions({
        slides,
        model,
        aiModels: slidesAiModels,
        opacityOptions,
      });

      exportToExcel(exportAIOptions);
    } finally {
      setIsExportingQuantification(false);
    }
  };

  return { isExportingQuantification, exportSlidesQuantification };
};
